import React from "react";
import { CardBodyProps } from "../../../types/components/Card";
import classNames from "classnames";

const CardBody: React.FC<CardBodyProps> = ({
  padding = 'default',
  className,
  children,
}) => (
  <div
    className={classNames(
      'bwp-card__body',
      { [`bwp-card__body--${padding}`]: padding && padding !== 'default' },
      className,
    )}
  >
    {children}
  </div>
);

export default CardBody;